<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <!-- List -->
        <div v-if="mode === 1">
          <div class="card">
            <div class="card-header">
              <a class="pull-right btn btn-success btn-sm btn-branch" exact @click="mode = 3">
                <i class="fa fa-plus" /> New
              </a>
            </div>
            <div class="card-block spinner-parent">
              <spinner ref="spinner" size="md" text="Loading ..." />
              <div class="table-responsive">
                <table v-show="entities.length" class="entities table table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Title</th>
                      <th>Publish_date</th>
                      <th>Unpublish date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in entities" :key="item.id" :data-id="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.publish_date }}</td>
                      <td>{{ item.unpublish_date }}</td>
                      <td class="table-list__cell--narrow">
                        <button
                          class="btn btn-primary btn-sm"
                          @click="editItem(item)"
                        >
                          Edit
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          @click="$_deleteEntity(item, 'announcements/', 'Announcement')"
                        >
                          Delete
                          <span :ref="`deleteBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                        </button>
                        <open-on-site
                          :source-route="item.route"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="!entities.length" class="text-center mt-2">
                  <strong>There are no announcements yet</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Edit -->
        <div v-if="mode === 2">
          <div class="card">
            <div class="card-header d-flex justify-content-between">
              <button class="btn btn-primary btn-sm mt-0 btn-branch" @click="mode = 1">
                <i class="fa fa-arrow-left" />
                Back
              </button>
              <!-- <strong>Edit</strong> -->
            </div>
          </div>
          <edit :item-to-edit="itemToEdit" @changeMode="setMode" />
        </div>
        <!-- New -->
        <div v-if="mode === 3">
          <div class="card">
            <div class="card-header">
              <a class="btn btn-success btn-sm btn-branch" @click="mode = 1">
                <i class="fa fa-arrow-left" /> Back
              </a>
            </div>
          </div>
          <new @changeModeOnCreate="setModeOnCreate" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

import Edit from './Edit.vue';
import New from './New.vue';

export default {
  name: 'Announcements',
  components: {
    Edit,
    New,
    'open-on-site': OpenOnSiteButton,
  },
  mixins: [ListPageMixin, CommonPageMixin],
  data() {
    return {
      mode: 1,
      itemToEdit: null,
      entities: [],
    };
  },
  methods: {
    editItem(item) {
      this.mode = 2;
      this.itemToEdit = item;
    },
    getSource() {
      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}announcements`, {
        params: {
          with: [
            'pdf',
            'cover',
          ],
          branch_id: this.$route.params.id,
        },
      })
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            const newDataArr = _.cloneDeep(response.data);
            delete newDataArr.meta;
            this.entities = Object.keys(newDataArr).map(e => newDataArr[e]);

            if (this.$refs.spinner) {
              this.$refs.spinner.hide();
            }
          }
        }).catch((error) => {
          console.error(error);
        });
    },
    setMode() {
      this.mode = 1;
      this.getSource();
    },
    setModeOnCreate() {
      this.mode = 1;
      this.getSource();
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?539f3884